import { get } from '../api.service';

export interface PieChartResponse {
  statusCode: number;
  message: string;
  response: {
    totalInvoiceAmount: number;
    onTimeAmount: number;
    overdue1To25Amount: number;
    overdue26To90Amount: number;
    onTimePercentage: number;
    overdue1To25Percentage: number;
    overdue26To90Percentage: number;
  };
  totalCount: number;
  numberOfPages: number;
}

export const fetchPieChartData = async (): Promise<PieChartResponse> => {
  try {
    const response = await get('userdashboard/pie-chart');
    return response;
  } catch (error) {
    console.error('Error fetching pie chart data:', error);
    throw error;
  }
};